import React, { useState, useEffect, useRef, useCallback } from "react";
//import jsPDF from "jspdf";
import FormSection from "../../components/FormSection";
import TodoList from "../../components/TodoList";
//import HiddenQRCode from "../../components/HiddenQRCode";
import ImageSelector from "../../components/ImageSelector";
import ImagePhoto from "../../components/ImagePhoto";
import ImagePhotoRound from "../../components/ImagePhotoRound";
import Semester from "../../components/Semester";
import { generatePDF } from "./generatePDF";

import "../../components/Leto.css";

function Leto() {
  // -------------------------
  // Form state
  // -------------------------
  const [formData, setFormData] = useState({
    name1: "",
    study1: "",
    AdmNo1: "",
    School1: "",
    comm: "",
    selection1: "Name",
    selection2: "Study",
    selection3: "AdmNo",
    selection4: "School",
    selection5: "Dream",
  });

  const [formData1, setFormData1] = useState({
    selection6: "Semester",
    selection7: "",
  });

  // -------------------------
  // Images & selectors
  // -------------------------
  const [imagesFromFolders, setImagesFromFolders] = useState([]); // for dynamic import (client)
  const [filteredImages, setFilteredImages] = useState([]);
  const [filter, setFilter] = useState("all");
  const [selectedImages, setSelectedImages] = useState([]);
  const [highlightedImages, setHighlightedImages] = useState([]);
  const [resetDefaults, setResetDefaults] = useState(0);
  const [showValidationMessage, setShowValidationMessage] = useState(false);

  // -------------------------
  // Model selection (rect/round/nop)
  // -------------------------
  const [model, setModel] = useState("rect");
  const handleChange5 = useCallback((e) => setModel(e.target.value), []);
  // Output sheet selection: A4 preserves the original 8-label layout;
  // Digital Print creates an exact 305 × 460 mm sheet with 25 labels.
  const [printMode, setPrintMode] = useState("a4");

  // -------------------------
  // Direct PDF download and uploaded border artwork
  // -------------------------
  const [isDownloading, setIsDownloading] = useState(false);
  const [uploadedBorders, setUploadedBorders] = useState([]);
  const [repeatUploadedBorders, setRepeatUploadedBorders] = useState(true);

  // -------------------------
  // Load images from client folders (webpack require.context)
  // -------------------------
  useEffect(() => {
    try {
      const importAllImages = (context) => context.keys().map(context);

      const loadedImages = [
        ...importAllImages(
          require.context("./images", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "general" })),
        ...importAllImages(
          require.context("./Animation", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "animation" })),
        ...importAllImages(
          require.context("./Technology", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "technology" })),
        ...importAllImages(
          require.context("./Sports", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "sports" })),
        ...importAllImages(
          require.context("./Science", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "science" })),
      ];

      setImagesFromFolders(loadedImages);
    } catch (err) {
      // in case require.context isn't available or folders not present — keep imagesFromFolders empty
      console.warn("Image folder import failed:", err);
    }
  }, []);

  const getFilteredImages = useCallback(() => {
    // Option B: show all images always, user requested unified borders
    return imagesFromFolders;
  }, [imagesFromFolders]);

  useEffect(() => {
    const all = getFilteredImages();
    if (filter === "all") setFilteredImages(all);
    else setFilteredImages(all.filter((img) => img.category === filter));
  }, [filter, imagesFromFolders, getFilteredImages]);

  // -------------------------
  // Validation & todos
  // -------------------------
  const namePattern =
    /^[\p{L}\p{N}'.:-]+(?: [\p{L}\p{N}'.@:-]+)* ?$/u; /* unicode letters+numbers */

  const formatName = useCallback((value) => {
    return value
      .toLowerCase()
      .replace(/ +/g, " ")
      .replace(/\b\w/g, (ch) => ch.toUpperCase());
  }, []);

  const defaultTodos = [];
  const [todos, setTodos] = useState(defaultTodos);
  const [errors, setErrors] = useState({});
  const [todoError, setTodoError] = useState("");


  const validateField = useCallback((name, value) => {
    let errorMessage = "";
    const v = (value || "").toString();

    if (!v.trim()) errorMessage = "This field is required";
    else if (v.length < 2) errorMessage = "Must be at least 2 characters";
    else if (v.length > 25) errorMessage = "Must not exceed 25 characters";
    else if (!namePattern.test(v)) errorMessage = "Spl chars ' . @ - : allows only ";

    setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    return errorMessage;
  }, []);

  // -------------------------
  // Input handlers
  // -------------------------
  const handleChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      const formattedValue = name === "AdmNo1" ? value : formatName(value);
      setFormData((prev) => ({ ...prev, [name]: formattedValue }));
      validateField(name, formattedValue);
    },
    [formatName, validateField]
  );

  const handleChange1 = useCallback((e) => {
    const { name, value } = e.target;
    setFormData1((prev) => ({ ...prev, [name]: value }));
  }, []);

  // -------------------------
  // Todos handlers
  // -------------------------
  const handleTodoInputChange = useCallback((newTodos) => {
    setTodos(newTodos);
    if (newTodos.length > 0) setTodoError("");
  }, []);

  const handleDeleteAllTodos = useCallback(() => setTodos([]), []);

  // -------------------------
  // Photo uploads
  // -------------------------
  const [photos, setPhotos] = useState([null, null, null, null]);
  const [validationMessage, setValidationMessage] = useState("");
  const fileInputsRef = useRef([]);
  const labels = ["Photo1", "Photo2", "Photo3", "Photo4"];

  const handlePhotoUpload = useCallback((photo, index) => {
    setPhotos((prev) => {
      const updated = [...prev];
      updated[index] = photo;
      if (updated.some(Boolean)) setValidationMessage("");
      return updated;
    });
  }, []);


  // -------------------------
  // Process / superscript helpers
  // -------------------------
  const processInput = useCallback((inputText) => {
    const cleanedInput = (inputText || "").replace(/[ʰ-˿ᴀ-ᵿ]/g, "");
    return cleanedInput.replace(/\b(\d+)\b/g, (match, number) => {
      const num = parseInt(number, 10);
      let suffix = "th";
      if (num % 10 === 1 && num % 100 !== 11) suffix = "st";
      else if (num % 10 === 2 && num % 100 !== 12) suffix = "nd";
      else if (num % 10 === 3 && num % 100 !== 13) suffix = "rd";
      return `${num}${suffix}`;
    });
  }, []);

  const addSuperscriptSuffix = useCallback((text) => {
    return (text || "").replace(/(\d+)(st|nd|rd|th)/g, (match, number, suffix) => {
      return `${number}${suffix}`;
    });
  }, []);

  // -------------------------
  // Form validation before payment / download
  // -------------------------
  const validateForm = useCallback(() => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (!key.includes("selection")) {
        const err = validateField(key, formData[key]);
        if (err) newErrors[key] = err;
      }
    });

    if (todos.length === 0) {
      newErrors.todoError = "Please add at least one subject.";
      setTodoError("Please add at least one subject.");
    } else setTodoError("");

    if (selectedImages.length === 0 && uploadedBorders.length === 0) {
      newErrors.imageError = "Please select a built-in border or upload at least one border image.";
      setShowValidationMessage(true);
    } else setShowValidationMessage(false);

    if (model !== "nop" && photos.every((p) => !p)) {
      setValidationMessage("Upload at least one photo");
      newErrors.photosError = "Upload at least one photo";
    } else setValidationMessage("");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [formData, photos, todos, selectedImages, uploadedBorders, validateField, model]);

  const convertUrlToBase64 = useCallback(async (url) => {
    if (!url || (typeof url === "string" && url.startsWith("data:"))) return url;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Unable to load image (${response.status})`);
    const blob = await response.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }, []);

  // -------------------------
  // Reset form after download (only when needed)
  // -------------------------
  const formRef = useRef(null);
  const resetForm = useCallback(() => {
    if (formRef.current) formRef.current.reset();

    setFormData({
      name1: "",
      study1: "",
      AdmNo1: "",
      School1: "",
      comm: "",
      selection1: "Name",
      selection2: "Study",
      selection3: "AdmNo",
      selection4: "School",
      selection5: "Dream",
    });

    setFormData1({ selection6: "Semester", selection7: "" });
    setTodos(defaultTodos);
    setTodoError("");
    setSelectedImages([]);
    setHighlightedImages([]);
    setFilter("all");
    setResetDefaults((s) => s + 1);
    setErrors({});
    setPhotos([null, null, null, null]);
    setUploadedBorders([]);
    setRepeatUploadedBorders(true);
    setModel("rect");
    setPrintMode("a4");
    setShowValidationMessage(false);
    fileInputsRef.current.forEach((inp) => inp && (inp.value = ""));
    setValidationMessage("");
  }, []);


  // -------------------------
  // Direct client-side PDF generation and download
  // -------------------------
  const downloadPDF = useCallback(async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      const selectedImagesBase64 = await Promise.all(
        selectedImages.map((image) => convertUrlToBase64(image))
      );
      const photosBase64 = await Promise.all(
        photos.map((photo) => photo ? convertUrlToBase64(photo) : null)
      );
      await generatePDF({
        formData,
        formData1,
        todos,
        selectedImages: selectedImagesBase64.filter(Boolean),
        photos: photosBase64,
        model,
        uploadedBorders,
        repeatUploadedBorders,
        printMode,
      });
      // Clear the form only after the PDF has been generated successfully.
      resetForm();
    } catch (err) {
      console.error("PDF generation failed:", err);
      window.alert("PDF generation failed. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  }, [
    isDownloading, formData, formData1, todos, selectedImages, photos,
    model, uploadedBorders, repeatUploadedBorders, printMode, convertUrlToBase64, resetForm,
  ]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    await downloadPDF();
  }, [validateForm, downloadPDF]);

  const handleBorderFiles = useCallback((event) => {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;
    const validFiles = files.filter((file) =>
      /^image\/(png|jpeg|jpg)$/i.test(file.type)
    );
    if (validFiles.length !== files.length) {
      window.alert("Please upload PNG or JPG image files only.");
    }
    const readers = validFiles.map((file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve({
        name: file.name,
        dataUrl: reader.result,
        type: file.type,
      });
      reader.onerror = reject;
      reader.readAsDataURL(file);
    }));
    Promise.all(readers)
      .then((newBorders) => setUploadedBorders((prev) => [...prev, ...newBorders]))
      .catch((error) => {
        console.error("Border image upload failed:", error);
        window.alert("Unable to read one or more border images.");
      });
    event.target.value = "";
  }, []);

  // -------------------------
  // UI
  // -------------------------
  return (
    <main className="pl-page">
      <div className="pl-shell">
        <header className="pl-hero">
          <div className="pl-brand-mark">TCW</div>
          <div className="pl-hero-copy">
            <span className="pl-eyebrow">TRINGE CREATIVE WORKS</span>
            <h1>Personalized Notebook Labels</h1>
            <p>Create beautiful, personalized labels for every subject — then download your print-ready PDF.</p>
          </div>
          <div className="pl-hero-art" aria-hidden="true">✦</div>
        </header>
        <div className="pl-progress">
          <span><b>01</b> Student details</span><i />
          <span><b>02</b> Subjects &amp; designs</span><i />
          <span><b>03</b> Photos &amp; download</span>
        </div>
        <form ref={formRef} onSubmit={handleSubmit} className="pl-form">
          <div className="pl-form-content" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "22px", width: "100%" }}>
            <fieldset
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                gap: "22px",
                width: "min(100%, 620px)",
                padding: "14px 18px",
                border: "2px solid #16833b",
                borderRadius: "12px",
                background: "#f4fff7",
                boxSizing: "border-box",
              }}
            >
              <legend style={{ padding: "0 8px", fontWeight: 700, color: "#166534" }}>
                Select PDF Print Size
              </legend>
              <label style={{ display: "inline-flex", alignItems: "center", gap: "8px", cursor: "pointer", fontWeight: 600 }}>
                <input
                  type="radio"
                  name="printMode"
                  value="a4"
                  checked={printMode === "a4"}
                  onChange={() => setPrintMode("a4")}
                />
                A4 Size
              </label>
              <label style={{ display: "inline-flex", alignItems: "center", gap: "8px", cursor: "pointer", fontWeight: 600 }}>
                <input
                  type="radio"
                  name="printMode"
                  value="digital"
                  checked={printMode === "digital"}
                  onChange={() => setPrintMode("digital")}
                />
                Digital Print (305 × 460 mm · 25 labels/page)
              </label>
            </fieldset>
            <div className="pl-details-grid">
            <FormSection
              formData={formData}
              handleChange={handleChange}
              errors={errors}
            />
            <Semester value={formData1} onChange={handleChange1} />
            </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0px",
              maxWidth: "100%",
            }}
          >
            <TodoList todos={todos} setTodos={handleTodoInputChange} />
            {todoError && <p style={{ color: "red" }}>{todoError}</p>}

            <button
              type="button"
              onClick={handleDeleteAllTodos}
              style={{
                marginTop: "10px",
                padding: "10px 20px",
                backgroundColor: "#ff4d4d",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Delete All Subjects
            </button>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              padding: "20px",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                padding: "20px",
                border: "2px solid #007bff",
                borderRadius: "10px",
                backgroundColor: "#f8f9fa",
                maxWidth: "100%",
              }}
            >
              <h3 style={{ textAlign: "center", color: "#007bff" }}>
                Choose Border Styles
              </h3>
              <ImageSelector
                images={filteredImages}
                selectedImages={selectedImages}
                highlightedImages={highlightedImages}
                setSelectedImages={setSelectedImages}
                setHighlightedImages={setHighlightedImages}
                setShowValidationMessage={setShowValidationMessage}
                setFilter={setFilter}
                showValidationMessage={showValidationMessage}
                resetDefaults={resetDefaults}
              />
            </div>

            <div style={{ padding: "18px", border: "2px dashed #6c63ff", borderRadius: "10px", background: "#fbfaff" }}>
              <h3 style={{ marginTop: 0, color: "#5146a5", textAlign: "center" }}>Upload Additional Border Images</h3>
              <p style={{ fontSize: "14px", color: "#555" }}>
                Upload multiple transparent PNG or JPG border designs. These are layered over the selected built-in border artwork in the PDF.
              </p>
              <input
                type="file"
                accept="image/png,image/jpeg"
                multiple
                onChange={handleBorderFiles}
              />
              {uploadedBorders.length > 0 && (
                <div style={{ marginTop: "12px" }}>
                  <strong>{uploadedBorders.length} uploaded border image(s)</strong>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                    {uploadedBorders.map((border, index) => (
                      <div key={`${border.name}-${index}`} style={{ width: "110px", padding: "6px", border: "1px solid #ddd", borderRadius: "8px", background: "#fff" }}>
                        <img src={border.dataUrl} alt={border.name} style={{ width: "100%", height: "75px", objectFit: "contain" }} />
                        <div style={{ fontSize: "11px", overflowWrap: "anywhere" }}>{border.name}</div>
                        <button type="button" onClick={() => setUploadedBorders((prev) => prev.filter((_, i) => i !== index))} style={{ marginTop: "5px", color: "#b00020", border: "none", background: "transparent", cursor: "pointer" }}>Remove</button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <fieldset style={{ border: 0, padding: 0, marginTop: "14px" }}>
                <legend style={{ fontWeight: 600, marginBottom: "8px" }}>How should uploaded borders be placed?</legend>
                <label style={{ display: "block", marginBottom: "7px" }}>
                  <input type="radio" name="repeatUploadedBorders" checked={repeatUploadedBorders} onChange={() => setRepeatUploadedBorders(true)} />
                  {" "}Repeat uploaded border images across all PDF labels (cycle through the images)
                </label>
                <label style={{ display: "block" }}>
                  <input type="radio" name="repeatUploadedBorders" checked={!repeatUploadedBorders} onChange={() => setRepeatUploadedBorders(false)} />
                  {" "}Use each uploaded border only once, in upload order
                </label>
              </fieldset>
            </div>
          </div>

          {/* Model Selection */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label
              htmlFor="photo-style"
              style={{
                fontSize: "1rem",
                fontWeight: "600",
                padding: "6px 12px",
                borderRadius: "10px",
                background: "linear-gradient(135deg, #fce4ec, #f8bbd0)",
                color: "#4a148c",
                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                border: "1px solid #f48fb1",
                whiteSpace: "nowrap",
              }}
            >
              Upload Photo Style
            </label>
            <select
              id="photo-style"
              value={model}
              onChange={handleChange5}
              style={{
                flex: "1",
                minWidth: "100px",
                padding: "8px 12px",
                borderRadius: "10px",
                border: "1px solid #ccc",
                fontSize: "1rem",
                background: "linear-gradient(135deg, #fefefe, #e0f7fa)",
                color: "#263238",
                boxShadow: "0px 4px 8px rgba(0,0,0,0.08)",
                transition: "background-color 0.3s ease",
                cursor: "pointer",
              }}
            >
              <option value="rect">Rectangle</option>
              <option value="round">Round</option>
              <option value="nop">No Photo</option>
            </select>
          </div>
        </div>

        {/* upload Photo */}
        {model !== "nop" && (
          <div className="container">
            <div className="grid-container">
              {labels.map((label, index) =>
                model === "rect" ? (
                  <ImagePhoto
                    key={index}
                    index={index}
                    label={label}
                    setImage={(photo) => handlePhotoUpload(photo, index)}
                    images={photos}
                    setImages={setPhotos}
                    fileInputsRef={fileInputsRef}
                    shape="rect"
                  />
                ) : (
                  <ImagePhotoRound
                    key={index}
                    index={index}
                    label={label}
                    setImage={(photo) => handlePhotoUpload(photo, index)}
                    images={photos}
                    setImages={setPhotos}
                    fileInputsRef={fileInputsRef}
                    shape="round"
                  />
                )
              )}
              {validationMessage && (
                <p className="validation-message">{validationMessage}</p>
              )}
            </div>
          </div>
        )}

        <button
          type="submit"
          className="pl-download-btn"
          disabled={isDownloading}
          style={{
            marginTop: "20px",
            padding: "12px 28px",
            backgroundColor: isDownloading ? "#777" : "#16833b",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: isDownloading ? "not-allowed" : "pointer",
            fontSize: "16px",
            fontWeight: 600,
          }}
        >
          {isDownloading ? "Generating PDF..." : "Download PDF"}
        </button>
        </form>
        <footer className="pl-footer">Made with care by <strong>Tringe Creative Works</strong> · Your details stay in this browser.</footer>
      </div>
    </main>
  );
}

export default Leto;
